import React from "react";
import { createPortal } from "react-dom";

// The mobile bar is `position: fixed`, so it must not live inside an ancestor
// that creates a containing block (transform / filter / backdrop-filter /
// will-change / contain). Portalling to <body> makes it viewport-relative
// regardless of what wrappers the page adds later.
const MOBILE_BASE =
  "block min-[880px]:hidden fixed left-0 w-full z-50 px-2 pb-4 pt-2 bottom-0";

const FixedBottomButton = ({
  children,
  className = "",
  classNameMobile = "",
  classNameDesktop = "",
}) => {
  const mobile = (
    <div className={[classNameMobile || MOBILE_BASE, className].join(" ")}>
      {children}
    </div>
  );

  return (
    <>
      {typeof document === "undefined"
        ? mobile
        : createPortal(mobile, document.body)}
      <div
        className={[
          "hidden min-[880px]:block md:max-w-[500px] mx-auto mt-5",
          classNameDesktop,
          className,
        ].join(" ")}
      >
        {children}
      </div>
    </>
  );
};

export default FixedBottomButton;
